import { DesignTimeErrorBoundaryData, ILogDto } from "@kuika/kuika-cl-model";
import jsonStringifySafe from "json-stringify-safe";
import { LogService } from "../../../services/log-service";
import { PartialContextProvider } from "../../../shared/patial/partial-context-provider";
import { KMainFunctions } from "../../../shared/utility/main-functions";
import { IScreenDesignContextState } from "../screen-design-context";
import { IScreenDesignContextProviderProps, ScreenDesignContextProvider } from "../screen-design-context-provider";

export interface ExceptionHandleProviderState {
  exceptionHandling: (errorBoundaryData: DesignTimeErrorBoundaryData) => void;
}

export class ExceptionHandleProvider extends PartialContextProvider<
  ScreenDesignContextProvider,
  IScreenDesignContextProviderProps,
  IScreenDesignContextState,
  ExceptionHandleProviderState
> {
  static defaultState: ExceptionHandleProviderState = {
    exceptionHandling: () => {}
  };

  getProviderValues = (): ExceptionHandleProviderState => {
    return {
      exceptionHandling: this.exceptionHandling
    };
  };

  exceptionHandling = async (errorBoundaryData: DesignTimeErrorBoundaryData) => {
    errorBoundaryData.screenId = this.partial.screenProvider.getScreenDesign().id;
    errorBoundaryData.projectId = this.state.project.id;

    const exceptionData = jsonStringifySafe(errorBoundaryData);

    const obj = {} as ILogDto;
    obj.level = "error";
    obj.method = "DesignLogs";
    obj.text = "Design-time exception.";
    obj.json = exceptionData;

    LogService.Log(obj);
    this.partial.screenProvider.undoForce();
    KMainFunctions.displayWarningNotification(
      "Your last change caused an error. Kuika logged this and recovered your screen. You can continue your work.",
      { duration: 7000 }
    );
  };
}
